/* =========================================================
   BLOCK THEME ADD-TO-CART (VERY IMPORTANT)
========================================================= */
document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest('button[type="submit"], input[type="submit"]');
    if (!btn) return;

    const form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    // 🚫 Stop theme ATC completely
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // ✅ Allow our submit handler to run ONCE
    if (!form.dataset.customAtcHandled) {
      form.dataset.customAtcHandled = "true";
      form.dispatchEvent(
        new Event("submit", { bubbles: true, cancelable: true })
      );
    }
  },
  true // ⚠️ CAPTURE PHASE (THIS IS THE KEY)
);


/* =========================================================
   GLOBAL ADD TO CART (FORM SUBMIT)
========================================================= */
document.addEventListener("submit", async function (e) {
    const form = e.target;
    if (!form || !form.action || !form.action.includes("/cart/add")) return;

    // Let THEME add product
    if (form.dataset.processing === "true") return;
    form.dataset.processing = "true";

    // UI only
    openCartDrawer();
    hideCartUI();
    showLoaderWhenDrawerOpens();
    refreshDrawerWhenOpened();

    try {
        // 1️⃣ Get cart BEFORE add
        const beforeCart = await fetch("/cart.js").then(r => r.json());
        const beforeTotal = beforeCart.total_price;

        // 2️⃣ WAIT until cart total changes
        let cart;
        for (let i = 0; i < 10; i++) { // max ~1s
            await new Promise(r => setTimeout(r, 100));
            cart = await fetch("/cart.js").then(r => r.json());
            if (cart.total_price !== beforeTotal) break;
        }

        if (!cart) return;

        const subtotal = cart.total_price / 100;

        const FREE_VARIANT1 = parseInt(window.freeGift?.variant1);
        const FREE_VARIANT2 = parseInt(window.freeGift?.variant2);
        const MIN = Number(window.freeGift?.min) || 0;
        const MAX = Number(window.freeGift?.max) || Infinity;

        const hasGift1 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT1);
        const hasGift2 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT2);

        /* ---------------- 🎁 GIFT RULES ---------------- */

        // BELOW MIN → remove both
        if (subtotal < MIN) {
            if (hasGift1) await removeGiftByVariant(cart, FREE_VARIANT1);
            if (hasGift2) await removeGiftByVariant(cart, FREE_VARIANT2);
        }

        // MIN ≤ subtotal < MAX → Gift 1 only
        else if (subtotal >= MIN && subtotal < MAX) {
            if (!hasGift1) await addGiftByVariant(FREE_VARIANT1);
            if (hasGift2) await removeGiftByVariant(cart, FREE_VARIANT2);
        }

        // subtotal ≥ MAX → Gift 2 only
        else {
            if (!hasGift2) await addGiftByVariant(FREE_VARIANT2);
            if (hasGift1) await removeGiftByVariant(cart, FREE_VARIANT1);
        }

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        showCartUIWithDelay();

    } catch (err) {
        console.error("Free gift logic error:", err);
    } finally {
        form.dataset.processing = "false";
    }
});


/* =========================================================
   PLUS BUTTON
========================================================= */
document.addEventListener("click", async function (e) {
    const plusBtn = e.target.closest(".ct_plus");
    if (!plusBtn) return;

    e.preventDefault();

    const FREE_VARIANT1 = parseInt(window.freeGift?.variant1);
    const FREE_VARIANT2 = parseInt(window.freeGift?.variant2);
    const MIN = Number(window.freeGift?.min);
    const MAX = Number(window.freeGift?.max);

    const lineItemEl = plusBtn.closest("line-item");
    const lineKey = lineItemEl?.getAttribute("data-item-key");
    const qty = parseInt(lineItemEl?.getAttribute("data-qty")) || 1;

    const cart = await fetch("/cart.js").then(r => r.json());
    const item = cart.items.find(i => i.key === lineKey);
    if (!item) return;

    const pricePerItem = item.final_line_price / item.quantity;
    const predictedSubtotal = (cart.total_price + pricePerItem) / 100;

    const hasGift1 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT1);
    const hasGift2 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT2);

    if (predictedSubtotal >= MIN && predictedSubtotal < MAX) {
        if (!hasGift1) await addGiftByVariant(FREE_VARIANT1);
        if (hasGift2) await removeGiftByVariant(cart, FREE_VARIANT2);
    } else if (predictedSubtotal >= MAX) {
        if (!hasGift2) await addGiftByVariant(FREE_VARIANT2);
        if (hasGift1) await removeGiftByVariant(cart, FREE_VARIANT1);
    }

    await updateQty(lineKey, qty + 1);
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    handleGiftLogic();
});

/* =========================================================
   MINUS BUTTON
========================================================= */
document.addEventListener("click", async function (e) {
    const minusBtn = e.target.closest(".ct_minus");
    if (!minusBtn) return;

    e.preventDefault();

    const FREE_VARIANT1 = parseInt(window.freeGift?.variant1);
    const FREE_VARIANT2 = parseInt(window.freeGift?.variant2);
    const MIN = Number(window.freeGift?.min);
    const MAX = Number(window.freeGift?.max);

    const lineItemEl = minusBtn.closest("line-item");
    const lineKey = lineItemEl?.getAttribute("data-item-key");
    const qty = parseInt(lineItemEl?.getAttribute("data-qty")) || 1;

    const cart = await fetch("/cart.js").then(r => r.json());
    const item = cart.items.find(i => i.key === lineKey);
    if (!item) return;

    const pricePerItem = item.final_line_price / item.quantity;
    const predictedSubtotal = (cart.total_price - pricePerItem) / 100;

    await updateQty(lineKey, qty - 1);

    const updatedCart = await fetch("/cart.js").then(r => r.json());
    const hasGift1 = updatedCart.items.some(i => parseInt(i.id) === FREE_VARIANT1);
    const hasGift2 = updatedCart.items.some(i => parseInt(i.id) === FREE_VARIANT2);

    if (predictedSubtotal < MIN) {
        if (hasGift1) await removeGiftByVariant(updatedCart, FREE_VARIANT1);
        if (hasGift2) await removeGiftByVariant(updatedCart, FREE_VARIANT2);
    } else if (predictedSubtotal >= MIN && predictedSubtotal < MAX) {
        if (!hasGift1) await addGiftByVariant(FREE_VARIANT1);
        if (hasGift2) await removeGiftByVariant(updatedCart, FREE_VARIANT2);
    } else {
        if (!hasGift2) await addGiftByVariant(FREE_VARIANT2);
        if (hasGift1) await removeGiftByVariant(updatedCart, FREE_VARIANT1);
    }

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    handleGiftLogic();
});

/* =========================================================
   HELPERS
========================================================= */
async function addItem(variantId) {
    return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
}

async function updateQty(key, qty) {
    return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    });
}

async function removeGiftByVariant(cart, variantId) {
    const item = cart.items.find(i => parseInt(i.id) === variantId);
    if (!item) return;

    return fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: item.key, quantity: 0 })
    });
}

async function addGiftByVariant(variantId) {
    return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
}

/* =========================================================
   DRAWER + UI
========================================================= */
function isDrawerOpen() {
    const d = document.querySelector("#cart-drawer");
    return d && getComputedStyle(d).display !== "none";
}

function openCartDrawer() {
    const d = document.querySelector("#cart-drawer");
    if (!d) return;
    d.style.display = "block";
    d.setAttribute("open", "");
    d.classList.add("open");
}

function refreshDrawerWhenOpened() {
    const d = document.querySelector("#cart-drawer");
    if (!d) return;

    const obs = new MutationObserver(() => {
        if (isDrawerOpen()) {
            document.addEventListener("cart:refresh", () => {
                    handleGiftLogic();
                });
            showCartUIWithDelay();
            obs.disconnect();
        }
    });

    obs.observe(d, { attributes: true, attributeFilter: ["style"] });
}

function showLoaderWhenDrawerOpens() {
    const d = document.querySelector("#cart-drawer");
    if (!d) return;

    if (isDrawerOpen()) {
        $(".ct-cart-drawer-main .ct-loader-main").show();
        return;
    }

    const obs = new MutationObserver(() => {
        if (isDrawerOpen()) {
            $(".ct-cart-drawer-main .ct-loader-main").show();
            obs.disconnect();
        }
    });

    obs.observe(d, { attributes: true, attributeFilter: ["style"] });
}

function hideCartUI() {
    const body = document.querySelector("#cart-drawer .drawer__inner");
    if (!body) return;
    body.style.opacity = "0";
    body.style.pointerEvents = "none";
}

function showCartUIWithDelay() {
    const body = document.querySelector("#cart-drawer .drawer__inner");
    if (!body) return;
    setTimeout(() => {
        body.style.opacity = "1";
        body.style.pointerEvents = "auto";
    }, 350);
}


/* =========================================================
   CART-BASED GIFT HANDLER (NO DUPLICATES – EVER)
========================================================= */
let giftLock = false;
let lastCartHash = null;

window.handleGiftLogic = async function () {
    if (giftLock) return;
    giftLock = true;

    const cart = await fetch("/cart.js").then(r => r.json());

    // Prevent duplicate execution on same cart
    const cartHash = cart.items.map(i => `${i.id}:${i.quantity}`).join("|");
    if (cartHash === lastCartHash) {
        giftLock = false;
        return;
    }
    lastCartHash = cartHash;

    const subtotal = cart.total_price / 100;

    const FREE_VARIANT1 = parseInt(window.freeGift?.variant1);
    const FREE_VARIANT2 = parseInt(window.freeGift?.variant2);
    const MIN = Number(window.freeGift?.min);
    const MAX = Number(window.freeGift?.max);

    const hasGift1 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT1);
    const hasGift2 = cart.items.some(i => parseInt(i.id) === FREE_VARIANT2);

    // BELOW MIN → remove both
    if (subtotal < MIN) {
        if (hasGift1) await removeGiftByVariant(cart, FREE_VARIANT1);
        if (hasGift2) await removeGiftByVariant(cart, FREE_VARIANT2);
    }

    // MIN ≤ subtotal < MAX → Gift 1 only
    else if (subtotal >= MIN && subtotal < MAX) {
        if (!hasGift1) await addGiftByVariant(FREE_VARIANT1);
        if (hasGift2) await removeGiftByVariant(cart, FREE_VARIANT2);
    }

    // subtotal ≥ MAX → Gift 2 only
    else {
        if (!hasGift2) await addGiftByVariant(FREE_VARIANT2);
        if (hasGift1) await removeGiftByVariant(cart, FREE_VARIANT1);
    }

    giftLock = false;
}
